import {
  INVOICE_REGENERATION_SUCCESS,
  INVOICE_REGENERATION_FAILED,
  RESET_INVOICE_REGENERATION,
  LOADING_INVOICE_REGENERATION,
  NETWORK_ERROR_INVOICE_REGENERATION,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_INVOICE_REGENERATION:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case INVOICE_REGENERATION_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case INVOICE_REGENERATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_INVOICE_REGENERATION:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_INVOICE_REGENERATION:
      return (state = initialState);
    default:
      return state;
  }
};
